import React from 'react';

const PopupContext = React.createContext();

export default PopupContext;